<template>
  <WdsCollapse
    v-if="show"
    :open="true"
    content-id="additional-information"
  >
    <template #title>
      <WdsStack justify-space-between align-center class="tw-w-full tw-py-2">
        <WdsStack align-center gap-sm>
          <WdsText large class="tw-font-semibold">
            {{ $t('Additional information') }}
            <span class="tw-text-indigo-500 tw-font-bold">*</span>
          </WdsText>
        </WdsStack>
        <WdsLabel
          v-if="!fieldsLoading"
          :success="completed"
          :warning="!completed"
          :subtle="completed"
          sm
        >
          {{ completed ? $t('Completed') : $t('Pending') }}
        </WdsLabel>
      </WdsStack>
    </template>
    <template #content>
      <WdsStack v-if="fieldsLoading" justify-center align-center class="tw-py-4">
        <WdsSpinner indeterminate />
      </WdsStack>
      <WdsStack v-else direction-column>
        <WdsText secondary sm>
          {{ $t('Information requested by :company', { company: companyName }) }}
        </WdsText>

        <WdsStack direction-column gap-md class="tw-mt-4">
          <FormCustomFields
            :field-values="modelValue"
            :field-value-fragments="fieldValueFragments"
            :loading="fieldsLoading"
            :fields="fields"
            :errors="errors"
            force-enable-inputs
            @update:field-values="$emit('update:modelValue', $event)"
          />
        </WdsStack>
      </WdsStack>
    </template>
  </WdsCollapse>
</template>

<script setup lang="ts">
import { Ref } from 'vue'
import {
  WdsCollapse,
  WdsLabel,
  WdsSpinner,
  WdsStack,
  WdsText,
} from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'
import FormCustomFields from '@/components/Fieldable/FormCustomFields.vue'
import {
  FieldableFormCustomFieldFragment,
  FieldableFormCustomFieldValueFragment,
} from '@/components/Fieldable/graphql/fragments'
import { CustomFieldTypeValueInput } from '@/gql/graphql'
import { FragmentType } from '@/gql'

const { $t } = useTranslation()

withDefaults(
  defineProps<{
    companyName: string
    fields: FragmentType<typeof FieldableFormCustomFieldFragment>[]
    fieldsLoading: boolean
    modelValue: CustomFieldTypeValueInput[]
    fieldValueFragments?: FragmentType<typeof FieldableFormCustomFieldValueFragment>[]
    errors: Record<string, Ref<string>>
    completed: boolean
    show: boolean
  }>(),
  {
    fieldValueFragments: () => [],
  },
)

defineEmits<{
  'update:modelValue': [value: CustomFieldTypeValueInput[]]
}>()
</script>
